'use strict';

goog.provide("Ntry.CodingpartyHint");

Ntry.CodingpartyHint = function() {
    this._view = Ntry.interfaceManager.getDom('ntryHintArea');
    this._currentIndex = 0;
    this._hints;
    this.createDom();
};

(function(p){

    p.createDom = function () {
        var that = this;
        var parent = this._view;

        var header = Ntry.createElement('div', parent, null, 'ntryHintHeader');

        this._hintNumber = Ntry.createElement('span', header, null, 'ntryHintQuestionNumber');

        var hintContainer = Ntry.createElement('span', header, null, 'codingpartyHintContainer');
        var hintTopDiv = Ntry.createElement('div', hintContainer, null, 'codingpartyHintTopDiv');
        this._hintTitle = Ntry.createElement('div', hintTopDiv, null, 'ntryHintTitle');
        this._hintsIndicator = Ntry.createElement('span', hintTopDiv, null, 'ntryHintsIndicator');
        this._hintContent = Ntry.createElement('div', hintContainer, null, 'ntryHintContent');

        this._hintThumbnail = Ntry.createElement('div', parent, null, 'cpatryHintThumbnail');
        this._hintDetail = Ntry.createElement('div', parent, null, 'ntryHintDetailView');

        this._hintModal = Ntry.createElement('div', parent, null, 'ntryHintModal');
        this._hintModal.ntryRemove();

        this._hintModal.bindOnClick(function(e) {
            if (e.target == this) {
                e.stopPropagation();
                e.preventDefault();
                that._hintModal.ntryRemove();
            }
        });

        var modalContainer = Ntry.createElement('div', this._hintModal, null, 'ntryHintModalContainer');
        var modalTitle = Ntry.createElement('div', modalContainer, null, 'ntryHintModalTitle')
        var modalText = Ntry.createElement('span', modalTitle, null, 'ntryModalTitleText');
        modalText.innerHTML = Lang.Menus.help;
        this._closeButton = Ntry.createElement('span', modalTitle, null, 'ntryHintModalCloseButton');
        this._modalContent = Ntry.createElement('div', modalContainer, null, 'ntryHintModalContent');
    };

    p.update = function() {
    };

    p.loadConfig = function () {
        this.position();

        this._hints = Ntry.configManager.getConfig('intro');
        this.fillHintContent();
    };

    p.fillHintContent = function () {
        var hints = this._hints,
            number = this._hintNumber,
            title = this._hintTitle,
            content = this._hintContent,
            indicator = this._hintsIndicator;

        var hint = hints;

        number.innerHTML = Lang.Menus.goals;
        content.innerHTML = hint.content;

        while(indicator.firstChild)
            indicator.removeChild(indicator.firstChild);

        if (hint.image) {
            var image = hint.image;


            this._hintThumbnail.removeClasses();
            this._hintThumbnail.addClass("cpartyHintThumbnail");
            this._hintThumbnail.addClass("cpartyHintThumbnail_"+image);
            if (image == 1 || image == 6 || image == 11)
                this._hintThumbnail.addClass(Lang.type);


            this._modalContent.removeClasses();
            this._modalContent.addClass("cpartyHintModalImage");
            this._modalContent.addClass("cpartyHintModalImage_"+image);
            if (image == 1 || image == 6 || image == 11)
                this._modalContent.addClass(Lang.type)

            var self = this;
            this._hintThumbnail.bindOnClick(function(e) {
                e.stopPropagation();
                e.preventDefault();
                self._hintModal.ntryShow();
            });

            this._closeButton.bindOnClick(function() {
                self._hintModal.ntryRemove();
            });
        }
    };

    p.position = function() {
        var gridSize = Ntry.configManager.getConfig("gridSize");
        var tileSize = Ntry.configManager.getConfig("tileSize");
        var engineHeight = $(Ntry.interfaceManager.getDom('ntryEngine')).height();
        var adjust = gridSize.height > 3 ? 1/gridSize.width*7 : 1;
        var top = gridSize.height*tileSize*adjust + engineHeight + 13;
        $(this._view).css('top', top+'px');
    };

})(Ntry.CodingpartyHint.prototype);


